/** Teksty nagłówków widoków (Hero 2.0): grupa bi. Klucze: heroBi.* */
export const heroBiPl = {
  common: {
    cmpPrev: 'poprzedni okres',
    cmpYoy: 'rok temu',
    ordersHint: 'zamówienia: {orders} · średnio {avg}',
    targetOf: 'cel {target}',
    targetPace: 'cel {target} · tempo {pace}',
    noTarget: 'brak celu na ten okres',
    marginPrev: '{pp} vs poprz. okres',
    marginYoy: '{pp} vs rok temu',
    activeHint: 'nowi: {new} · utraceni: {lost}',
    activeCustomers: 'Klienci aktywni',
    targetPct: 'Realizacja celu',
    marginPct: 'Marża %',
    sales: 'Sprzedaż netto',
  },
  actions: {
    team: 'Zespół',
    mine: 'Mój wynik',
    customersAnalysis: 'Analiza klientów',
    productsAnalysis: 'Analiza produktów',
    customersList: 'Lista klientów',
    alerts: 'Alerty',
    tasks: 'Zadania',
  },
  board: {
    behind: 'Realizacja celu: {pct} przy upływie {elapsed} okresu — do celu brakuje {gap}.',
    missed: 'Cel okresu nieosiągnięty: {pct} — brakuje {gap}.',
    drop: 'Sprzedaż spadła o {pct} vs {cmp}.',
    dropRep: 'Sprzedaż spadła o {pct} vs {cmp}. Największy spadek: {rep} ({repPct}).',
    lostMore: 'Utraciliśmy więcej klientów niż pozyskaliśmy: utraceni {lost}, nowi {new}.',
    criticalAlerts: 'Krytyczne alerty do obsłużenia: {count}.',
    reached: 'Cel okresu osiągnięty: {pct} realizacji.',
    growth: 'Sprzedaż rośnie o {pct} vs {cmp}, marża {margin}.',
    stable: 'Sprzedaż {amount}, marża {margin} — brak sygnałów ostrzegawczych.',
    seeTeam: 'Zobacz zespół',
    seeLost: 'Utraceni klienci',
    seeAlerts: 'Alerty',
  },
  team: {
    repsBehind: 'Poniżej tempa celu',
    repsBehindHint: 'z {total} handlowców z celem',
    declining: 'Klienci ze spadkiem',
    decliningHint: 'sprzedaż niższa o 15% lub więcej',
    behind: 'Poniżej tempa celu: {count} z {total} handlowców. Najniżej: {rep} ({pct}).',
    declineTop: 'Klienci ze spadkiem sprzedaży o 15% lub więcej: {count}. Najwięcej: {rep} ({n}).',
    onTrack: 'Zespół w tempie celu ({pct}) — brak handlowców poniżej planu.',
    stable: 'Sprzedaż zespołu {amount}, marża {margin} — brak sygnałów ostrzegawczych.',
    seeRep: 'Wynik handlowca',
    seeList: 'Pokaż listę',
  },
  rep: {
    opportunities: 'Potencjał z luk',
    opportunitiesHint: 'klienci z lukami: {customers} · miesięcznie',
    behind: 'Realizujesz {pct} celu przy upływie {elapsed} okresu — brakuje {gap}.',
    missed: 'Cel okresu nieosiągnięty: {pct} — brakuje {gap}.',
    declineTop: 'Największy spadek sprzedaży: {name} ({pct}). Zadzwoń lub odwiedź klienta.',
    gaps: 'Luki w asortymencie u {customers} klientów — potencjał około {amount} miesięcznie.',
    reached: 'Cel okresu osiągnięty: {pct} realizacji.',
    stable: 'Sprzedaż {amount}, marża {margin} — brak sygnałów ostrzegawczych.',
    seeList: 'Pokaż listę',
    seeGaps: 'Luki i koszyk',
  },
  customers: {
    abcA: 'Klasa A — udział w sprzedaży',
    abcAHint: 'klienci: {count} · top 10: {top10}',
    retention: 'Retencja po 3 miesiącach',
    retentionHint: 'przychód {rev} · pozyskani: {acquired}',
    retentionHintShort: 'pozyskani: {acquired}',
    churn: 'Wysokie ryzyko odejścia',
    churnHint: '{sales} sprzedaży 12 m',
    lost: 'Utraceni klienci',
    lostHint: 'odzyskani: {recovered} · utracony obrót {amount}',
    churnInsight: 'Klienci z wysokim ryzykiem odejścia: {count}, razem {sales} sprzedaży 12 m. Zacznij od: {name}.',
    churnInsightNoName: 'Klienci z wysokim ryzykiem odejścia: {count}, razem {sales} sprzedaży 12 m.',
    lostInsight: 'Utraceni klienci: {lost} (utracony obrót {amount}), odzyskani: {recovered}.',
    concentration: 'Top 10 klientów to {pct} sprzedaży — duże uzależnienie od kilku odbiorców.',
    healthy: 'Portfel w dobrej kondycji: brak klientów wysokiego ryzyka, odzyskani nie ustępują utraconym.',
    seeChurn: 'Ryzyko odejścia',
    seeLost: 'Utraceni i odzyskani',
    seeAbc: 'Klasyfikacja ABC',
  },
  products: {
    net: 'Sprzedaż produktów',
    netHint: 'sprzedane: {sold} · bez sprzedaży: {unsold}',
    top: 'Udział top produktu',
    topHint: '{name}',
    margin: 'Marża %',
    marginHint: 'marża {amount}',
    crossSell: 'Potencjał cross-sell',
    crossSellHint: 'klienci z lukami: {customers} · miesięcznie',
    decline: 'Sprzedaż produktów spadła o {pct} vs poprzedni okres.',
    cows: 'Krowy dojne generują {cows} sprzedaży, gwiazdy {stars} — pilnuj cen i kosztów produktów o dużym wolumenie.',
    crossSellPair: 'Luki asortymentowe u {customers} klientów (około {amount} miesięcznie). Najsilniejsza para w koszyku: {a} + {b} (lift {lift}).',
    crossSellInsight: 'Luki asortymentowe u {customers} klientów — potencjał około {amount} miesięcznie.',
    mix: 'Dominuje grupa {group} ({share} sprzedaży), marża całości {margin}.',
    stable: 'Brak sygnałów ostrzegawczych w strukturze sprzedaży produktów.',
    seeLost: 'Produkty utracone',
    seeMargin: 'Marża × wolumen',
    seeWhite: 'Luki i koszyk',
  },
};

export const heroBiEn: typeof heroBiPl = {
  common: {
    cmpPrev: 'the previous period',
    cmpYoy: 'last year',
    ordersHint: 'orders: {orders} · average {avg}',
    targetOf: 'target {target}',
    targetPace: 'target {target} · pace {pace}',
    noTarget: 'no target for this period',
    marginPrev: '{pp} vs prev. period',
    marginYoy: '{pp} vs last year',
    activeHint: 'new: {new} · lost: {lost}',
    activeCustomers: 'Active customers',
    targetPct: 'Target attainment',
    marginPct: 'Margin %',
    sales: 'Net sales',
  },
  actions: {
    team: 'Team',
    mine: 'My result',
    customersAnalysis: 'Customer analysis',
    productsAnalysis: 'Product analysis',
    customersList: 'Customer list',
    alerts: 'Alerts',
    tasks: 'Tasks',
  },
  board: {
    behind: 'Target attainment: {pct} with {elapsed} of the period elapsed — {gap} short of the target.',
    missed: 'Period target missed: {pct} — {gap} short.',
    drop: 'Sales are down {pct} vs {cmp}.',
    dropRep: 'Sales are down {pct} vs {cmp}. Biggest drop: {rep} ({repPct}).',
    lostMore: 'We lost more customers than we won: lost {lost}, new {new}.',
    criticalAlerts: 'Critical alerts to handle: {count}.',
    reached: 'Period target reached: {pct} attainment.',
    growth: 'Sales are up {pct} vs {cmp}, margin {margin}.',
    stable: 'Sales {amount}, margin {margin} — no warning signals.',
    seeTeam: 'See the team',
    seeLost: 'Lost customers',
    seeAlerts: 'Alerts',
  },
  team: {
    repsBehind: 'Behind target pace',
    repsBehindHint: 'of {total} reps with a target',
    declining: 'Declining customers',
    decliningHint: 'sales down 15% or more',
    behind: 'Behind target pace: {count} of {total} reps. Lowest: {rep} ({pct}).',
    declineTop: 'Customers with sales down 15% or more: {count}. Most: {rep} ({n}).',
    onTrack: 'Team on target pace ({pct}) — no rep is behind plan.',
    stable: 'Team sales {amount}, margin {margin} — no warning signals.',
    seeRep: 'Rep result',
    seeList: 'Show list',
  },
  rep: {
    opportunities: 'Gap potential',
    opportunitiesHint: 'customers with gaps: {customers} · monthly',
    behind: 'You are at {pct} of target with {elapsed} of the period elapsed — {gap} short.',
    missed: 'Period target missed: {pct} — {gap} short.',
    declineTop: 'Biggest sales drop: {name} ({pct}). Call or visit the customer.',
    gaps: 'Assortment gaps at {customers} customers — about {amount} potential per month.',
    reached: 'Period target reached: {pct} attainment.',
    stable: 'Sales {amount}, margin {margin} — no warning signals.',
    seeList: 'Show list',
    seeGaps: 'Gaps and basket',
  },
  customers: {
    abcA: 'Class A — share of sales',
    abcAHint: 'customers: {count} · top 10: {top10}',
    retention: 'Retention after 3 months',
    retentionHint: 'revenue {rev} · acquired: {acquired}',
    retentionHintShort: 'acquired: {acquired}',
    churn: 'High churn risk',
    churnHint: '{sales} of 12-month sales',
    lost: 'Lost customers',
    lostHint: 'recovered: {recovered} · lost turnover {amount}',
    churnInsight: 'Customers at high risk of churn: {count}, together {sales} of 12-month sales. Start with: {name}.',
    churnInsightNoName: 'Customers at high risk of churn: {count}, together {sales} of 12-month sales.',
    lostInsight: 'Lost customers: {lost} (lost turnover {amount}), recovered: {recovered}.',
    concentration: 'The top 10 customers make up {pct} of sales — heavy reliance on a few buyers.',
    healthy: 'Healthy portfolio: no high-risk customers and recoveries keep up with losses.',
    seeChurn: 'Churn risk',
    seeLost: 'Lost and recovered',
    seeAbc: 'ABC classification',
  },
  products: {
    net: 'Product sales',
    netHint: 'sold: {sold} · unsold: {unsold}',
    top: 'Top product share',
    topHint: '{name}',
    margin: 'Margin %',
    marginHint: 'margin {amount}',
    crossSell: 'Cross-sell potential',
    crossSellHint: 'customers with gaps: {customers} · monthly',
    decline: 'Product sales are down {pct} vs the previous period.',
    cows: 'Cash cows bring {cows} of sales, stars {stars} — watch prices and costs of high-volume products.',
    crossSellPair: 'Assortment gaps at {customers} customers (about {amount} per month). Strongest basket pair: {a} + {b} (lift {lift}).',
    crossSellInsight: 'Assortment gaps at {customers} customers — about {amount} potential per month.',
    mix: 'Group {group} dominates ({share} of sales), overall margin {margin}.',
    stable: 'No warning signals in the product sales structure.',
    seeLost: 'Lost products',
    seeMargin: 'Margin × volume',
    seeWhite: 'Gaps and basket',
  },
};
